import { download } from './data_repository';

export function downloadTermsAndConditionsFile() {
  const termsAndConditionsFileEndPoint = '/file/downloadTermsAndConditions';

  return download({ url: termsAndConditionsFileEndPoint });
}
